import { Form } from "antd";


/**
 * A hook to watch variables
 * @param {*} variable
 * @returns
 */
const useWatchForm = (form, variable) => {
  return Form.useWatch(variable, form?.current || form || {})
};

export default useWatchForm;
